<template>
  <tk-container class="water" :status="status" @refresh="initData">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      用电量
    </tkui-header>
    <div class="body">
      <tk-flex middle center class="btn" style="position: relative;">
        {{selected.join(' - ')}}&nbsp;&nbsp;
        <tk-icon style="width: 14px;color: #7AB8B7;">dropdown</tk-icon>
        <tkui-list style="position: absolute;width: 100%;height: 100%;opacity: 0;">
          <tkui-list-picker @selected="select" v-model="selected" :items="date" label=""></tkui-list-picker>
        </tkui-list>
      </tk-flex>
      <tk-flex average center middle>
        <tk-flex column center middle class="border">
          <p class="num">{{yearAmount|num}}度</p>
          <p class="name">年用电量</p>
        </tk-flex>
        <tk-flex column center middle>
          <p class="num">{{monthAmount|num}}度</p>
          <p class="name">月用电量</p>
        </tk-flex>
      </tk-flex>
      <div class="chartBox">
        <div class="chart" ref="chart"></div>
      </div>
    </div>
  </tk-container>
</template>

<script>
  import echart from 'echarts'
  import moment from 'moment'
  let current = new Date()
  let month = current.getMonth() + 1
  let year = current.getFullYear()
  let years = require('../../../assets/js/year.js').default(year)
  export default {
    data () {
      return {
        status: false,
        selected: [year.toString(), month.toString()],
        oldSelect: [year.toString(), month.toString()],
        date: [
          years,
          ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        ],
        records: [],
        totalRecord: {},
        totalAmount: 0,
        monthAmount: 0,
        data: [],
        days: [],
        opt: {
          grid: {
            show: false,
            left: 15,
            right: 15
          },
          xAxis: {
            show: true,
            data: [],
            type: 'category',
            boundaryGap: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#505E5E',
              fontSize: 12
            },
            triggerEvent: true
          },
          yAxis: {
            show: false
          },
          series: [{
            type: 'line',
            smooth: true,
            data: [],
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#00A9FF'
                  },
                  {
                    offset: 1,
                    color: '#ffffff'
                  }
                ]
              }
            },
            lineStyle: {
              color: '#00A9FF',
              width: '4'
            },
            symbol: 'circle',
            symbolSize: 11,
            showSymbol: true,
            itemStyle: {
              color: '#0091FF',
              borderColor: '#ffffff',
              borderWidth: 3,
              borderType: 'solid',
              shadowColor: '#0091FF',
              shadowBlur: 6,
              shadowOffsetY: 0,
              shadowOffsetX: 0
            }
          }],
          tooltip: {
            trigger: 'item',
            position: 'top',
            backgroundColor: '#0091FF',
            padding: [0, 12, 0, 0],
            textStyle: {
              color: '#ffffff',
              fontSize: 12
            }
          },
          dataZoom: [
            {
              type: 'inside',
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 25,
              zoomLock: true
            }
          ],
          animation: false
        }
      }
    },
    computed: {
      machine () {
        return this.$store.state.machine
      },
      yearAmount () {
        let amount = 0
        if (this.records.length > 0) {
          this.records.forEach(record => {
            amount += record.electric
          })
        }
        return amount
      }
    },
    created () {
      this.oldSelect = [...this.selected]
      this.initData()
    },
    mounted () {
      this.initChart()
    },
    methods: {
      back () {
        this.$back()
      },
      async initData (params) {
        let date
        if (params) {
          date = moment(params)
        } else {
          date = moment()
        }
        let start = date.startOf('year').toISOString()
        let end = date.endOf('year').toISOString()
        try {
          this.status = 'loading'
          let records = await this.$tkParse.getList('/classes/elecWaterRecord', {
            'params': {
              'where': {
                'machine': this.machine.objectId,
                'date': {
                  '$gte': {
                    '__type': 'Date',
                    'iso': start
                  },
                  '$lte': {
                    '__type': 'Date',
                    'iso': end
                  }
                }
              },
              'order': 'date',
              'limit': 400
            }
          })
          this.records = [...records]
          this.totalRecord = {}
          if (records.length > 0) {
            records.forEach(record => {
              let month = moment(record.date).month() + 1
              if (this.totalRecord[month]) {
                this.totalRecord[month].push({
                  day: moment(record.date).date(),
                  record: record.electric
                })
              } else {
                this.totalRecord[month] = [{
                  day: moment(record.date).date(),
                  record: record.electric
                }]
              }
            })
            this.getMonthAmount(params)
          }
          this.status = false
        } catch (e) {
          this.status = 'error'
          this.$tkGlobal.toast.add('获取数据失败')
        }
      },
      getMonthAmount (params) {
        let month = params ? moment(params).month() + 1 : moment().month() + 1
        let dateNum = params ? moment(params).daysInMonth() : moment().daysInMonth()
        let amount = 0
        this.data = []
        this.days = []
        if (this.totalRecord[month]) {
          for (let i = 0; i < dateNum; i++) {
            this.days.push(i + 1 + '日')
            this.data.push(0)
          }
          this.totalRecord[month].forEach((record) => {
            amount += record.record
            this.data.splice(record.day - 1, 1, record.record)
          })
        }
        this.monthAmount = amount
        if (this.$refs.chart) {
          this.initChart()
        }
      },
      select () {
        if (Number(this.selected[0]) === Number(this.oldSelect[0]) && Number(this.selected[1]) === Number(this.oldSelect[1])) return
        if (Number(this.selected[0]) === Number(this.oldSelect[0]) && Number(this.selected[1]) !== Number(this.oldSelect[1])) {
          let date = new Date(this.selected.join('-'))
          this.initData(date)
        }
        if (Number(this.selected[0]) !== Number(this.oldSelect[0])) {
          let date = new Date(this.selected.join('-'))
          this.initData(date)
        }
        this.oldSelect = [...this.selected]
      },
      initChart () {
        this.chart = echart.init(this.$refs.chart)
        this.opt.xAxis.data = this.days
        this.opt.series[0].data = this.data
        this.chart.setOption(this.opt)
      }
    },
    filters: {
      num (val) {
        return Number(val).toFixed(1)
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .water{
    background: #ffffff;
    .body{
      .btn{
        margin: 25px auto;
        width: 134px;
        height: 34px;
        border-radius: 17px;
        background: #ffffff;
        color: #0091ff;
        font-size: 16px;
        font-weight: 700;
        box-shadow:0px 4px 5px rgba(31,131,207,0.15);
      }
      .border{
        border-right: 1px solid #B0D3D2;
      }
      .num{
        color: #0091FF;
        font-size: 16px;
        font-weight: 700;
      }
      .name{
        font-size: 14px;
        color: #999999;
        margin-top: 5px;
      }
      .chartBox{
        width: 100%;
        height: 240px;
        .chart{
          height: 100%;
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/chart/electricChart.vue